import { MetadataSectionTypes } from "types";
import {
  SET_SELECTED_SECTION,
  SET_SHOW_MISLABEL_RANGE,
  SET_SHOW_DUPLICATE_RANGE,
} from "./constants";

export const setSelectedSection = (data: MetadataSectionTypes) => {
  return { type: SET_SELECTED_SECTION, data };
};

export const setShowMislabelsRange = (data: boolean) => {
  return { type: SET_SHOW_MISLABEL_RANGE, data };
};

export const setShowDuplicatesRange = (data: boolean) => {
  return { type: SET_SHOW_DUPLICATE_RANGE, data };
};
